import React, { FC, useEffect, useState } from 'react';
import Image from 'next/image';
import { Card } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { IBalanceCardProps } from '@/components/BalanceSlide';
import Toast from '@/components/Toast';
import { UserStatusOnClickWrapper } from '@/userStatus/components';
import { classnames } from '@/utils/classnames';
import { HamiBalanceSlideBackgroundOverlay } from './HamiBalanceSlideBackgroundOverlay';

export interface IHamiBalanceSlideCardProps extends IBalanceCardProps {
  buttonProps?: TButtonProps;
  refetch: () => {};
  isFetching: boolean;
  isError: boolean;
  showBalance: boolean;
  setShowBalance: (__value: boolean) => void;
}

const HamiBalanceSlideCard: FC<IHamiBalanceSlideCardProps> = ({
  title,
  amount,
  currency = 'ریال',
  buttonTitle,
  buttonAction,
  className,
  isMasked,
  buttonProps,
  isFetching,
  refetch,
  onMaskChange,
  isError,
  showBalance,
  setShowBalance,
  ...rest
}) => {
  const [shouldFetch, setShouldFetch] = useState(false);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const timer =
      seconds > 0 && setInterval(() => setSeconds(seconds - 1), 1000);
    if (timer) return () => clearInterval(timer);
  }, [seconds]);

  useEffect(() => {
    if (!isFetching && seconds === 0) {
      if (shouldFetch === true)
        Toast.open({
          variant: 'info',
          children: `موجودی با موفقیت بروزرسانی شد.`,
        });
      setShouldFetch(false);
    }
  }, [isFetching, seconds]);

  return (
    <Card
      className={classnames(
        '!absolute right-0 top-0 h-[160px] overflow-hidden rounded-2xl text-white',
        className
      )}
      style={{
        backfaceVisibility: 'hidden',
      }}
      {...rest}
    >
      <HamiBalanceSlideBackgroundOverlay />
      <div className="flex h-full flex-col justify-between p-2 !pb-1 md:!px-6 md:!pt-2">
        <div className="z-30 flex justify-between">
          <Image
            alt="کارگزاری مفید"
            height={31}
            src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/logo/logo-1.webp"
            width={100}
            priority
          />
          {buttonTitle && buttonAction && (
            <UserStatusOnClickWrapper>
              <button
                {...buttonProps}
                className="flex items-center justify-center rounded-lg border-0 bg-white/20 p-2 !pr-3 text-[10px] font-medium text-green-a40"
                onClick={buttonAction}
              >
                {buttonTitle}
                <Icon icon="chevron_left" size={14} />
              </button>
            </UserStatusOnClickWrapper>
          )}
        </div>

        <div className="z-30 flex justify-between">
          <div className="text-sm font-demibold !leading-4 md:-mt-[5px] md:!text-base">
            {title}
          </div>
        </div>

        <div className="relative">
          <div className="absolute bottom-0 left-0 flex flex-col items-end gap-5 md:bottom-[6px] md:gap-7">
            <span className="text-2xl font-demibold !leading-[0] ltr">
              {isMasked ? '**********' : amount}
            </span>
            <span className="z-[10] text-sm font-regular !text-gray-50 opacity-70">
              {currency}
            </span>
          </div>

          <div className="sticky bottom-5 z-50 flex w-fit items-center">
            {!showBalance && (
              <UserStatusOnClickWrapper>
                <button
                  className="flex h-8 w-[100px] items-center justify-center rounded-md border border-solid border-gray-20 text-xxs font-regular"
                  id="home_click_showHamiBalance"
                  onClick={() => {
                    setShowBalance(true);
                    refetch();
                  }}
                >
                  مشاهده موجودی
                </button>
              </UserStatusOnClickWrapper>
            )}

            {!isError && showBalance && (
              <UserStatusOnClickWrapper>
                <div
                  className="z-50 flex h-8 w-8 cursor-pointer items-center justify-center rounded-[8px] border border-solid border-[#fff] "
                  onClick={() => onMaskChange?.(!isMasked)}
                >
                  <Icon
                    icon={
                      !isMasked
                        ? 'visibility_off_outline'
                        : 'visibility_outline'
                    }
                    size={20}
                  />
                </div>

                <div
                  className={`disabled first-letter z-50 mr-5 flex h-8 w-8 cursor-pointer items-center justify-center rounded-[8px] border border-solid border-[#fff] ${
                    (isFetching || seconds > 0) &&
                    'cursor-not-allowed opacity-30'
                  }`}
                  onClick={() => {
                    if (!isFetching && seconds === 0) {
                      setSeconds(2);
                      setShouldFetch(true);
                      refetch();
                    }
                  }}
                >
                  <Icon
                    className={` ${
                      ((isFetching && shouldFetch) || seconds > 0) &&
                      'animate-spin'
                    }`}
                    icon={'refresh'}
                    size={20}
                  />
                </div>
              </UserStatusOnClickWrapper>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};
export default HamiBalanceSlideCard;
